import { mfaHeaders } from '~/api/auth-headers';
import { backendApiGateway } from '~/client/backend';
import { EmailOtpChallengeResult, EmailOtpSendResult } from '~/types/emailOtp';

/**
 * Login-challenge (phase 2): sends a fresh code to the user's email, authorized
 * by the pre-auth `mfa_token`. Same 60s resend cooldown as the post-login send
 * (429 inside the window). 401 → mfa_token expired → back to login.
 */
export const sendEmailOtpChallenge = async (mfaToken: string): Promise<EmailOtpSendResult> => {
  const { data } = await backendApiGateway.post<EmailOtpSendResult>(
    'api/auth/email_otp/challenge/send',
    undefined,
    mfaHeaders(mfaToken),
  );
  return data;
};

/**
 * Login-challenge (phase 2): verifies the emailed code against the `mfa_token`.
 * On success completes the login (`{ token }` + session cookie). Rejects with
 * 401 (mfa_token expired/no pending code → back to login), 422 (wrong code),
 * 429 (too many attempts → request a new code).
 */
export const verifyEmailOtpChallenge = async (code: string, mfaToken: string): Promise<EmailOtpChallengeResult> => {
  const { data } = await backendApiGateway.post<EmailOtpChallengeResult>(
    'api/auth/email_otp/challenge/verify',
    { code },
    mfaHeaders(mfaToken),
  );
  return data;
};
